var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.732,13.768c-.472-.473-.732-1.101-.732-1.768s.26-1.295.734-1.77L18.026.852c.194-.196.193-.513-.003-.707-.197-.194-.513-.192-.707.004l-9.291,9.377c-.661.661-1.025,1.54-1.025,2.475s.364,1.813,1.024,2.473l9.292,9.379c.098.099.226.148.355.148.127,0,.254-.048.352-.145.196-.194.197-.511.003-.707l-9.294-9.381Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.35e51fd4984c4f227e0922b6f3790e53.svg";
export { ForwardRef as ReactComponent };